import { useTranslation } from "react-i18next";
import { HistoryControls } from "../history/HistoryControls";
import { LanguagePicker } from "./LanguagePicker";
import { SaveActions } from "./SaveActions";
import { ArrowLeft } from "lucide-react";
import { Button } from "../ui/button";
import { useMetadataBuilderStore } from "../../stores/metadata-builder-store";
import { closeMetadataBuilder } from "../../lib/metadata-builder/session";

export function AppNav() {
  const { t } = useTranslation();
  const builderActive = useMetadataBuilderStore(state => state.active);
  return (
    <nav className="flex min-h-16 flex-wrap gap-3 py-3 items-center justify-between border-b border-neutral-200 bg-white px-4 min-[480px]:px-6" aria-label={t("nav.label")}>
      <h1 className="text-sm font-semibold">{t("app.title")}</h1>
      <div className="flex min-w-0 flex-wrap items-center justify-end gap-3">
        {builderActive && <Button variant="outline" size="sm" onClick={closeMetadataBuilder}>
          <ArrowLeft />
          {t("builder.exit")}
        </Button>}
        <HistoryControls />
        <LanguagePicker />
        {!builderActive && <SaveActions />}
      </div>
    </nav>
  );
}
